<template>
  <el-card class="v_ent_list">
    <div class="g-flex"  slot="header">
      <span>企业账号列表</span>
      <div class="g-flex-justify-end g-flex-1">
        <el-button v-if="auth.saveEnt" size="mini" type="success" @click="setForm()">新增账号</el-button>
      </div>
    </div>
    <!-- 搜索 -->
    <el-form :inline="true" size="mini" :model="query">
      <el-form-item>
        <el-select slot="label" v-model="query.search_key" placeholder="查询">
          <el-option label="用户名" value="user_name"></el-option>
        </el-select>
        <el-row>
          <el-col :span="18">
            <el-input v-model="query.search_val" @keyup.enter.native="getList()" @clear="getList()" placeholder="请输入查找内容" clearable></el-input>
          </el-col>
          <el-col :span="5" :offset="1">
            <el-button type="primary" @click="getList()">查询</el-button>
          </el-col>
        </el-row>
      </el-form-item>
    </el-form>

    <!-- 表格 -->
    <el-table stripe size="mini" v-loading="table.loading" :data="table.rows" border>
      <el-table-column prop="id" label="企业ID" width="80" :show-overflow-tooltip="true"/>
      <el-table-column prop="user_name" label="用户名" width="150" :show-overflow-tooltip="true"/>
      <el-table-column prop="name" label="姓名" width="120" :show-overflow-tooltip="true"/>
      <el-table-column prop="remark" label="备注" :show-overflow-tooltip="true"/>
      <el-table-column prop="ip" label="ip" width="100" :show-overflow-tooltip="true"/>
      <el-table-column prop="ip_address" label="ip地址" :show-overflow-tooltip="true"/>
      <el-table-column label="创建时间" width="140" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <span>{{formatDate(scope.row.create_time, 'yyyy-MM-dd hh:mm')}}</span>
        </template>
      </el-table-column>
      <el-table-column label="到期时间" width="140" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <span>{{formatDate(scope.row.expire_time, 'yyyy-MM-dd hh:mm')}}</span>
        </template>
      </el-table-column>
      <el-table-column label="登录时间" width="140" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <span>{{formatDate(scope.row.login_time, 'yyyy-MM-dd hh:mm')}}</span>
        </template>
      </el-table-column>
      <el-table-column label="状态" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span v-if="scope.row.status==0" class="g-red">禁用</span>
            <span v-else-if="scope.row.status==1" class="g-green">正常</span>
          </template>
      </el-table-column>
      <el-table-column v-if="auth.saveEnt||auth.delEnt"  label="操作" width="260">
        <template slot-scope="scope">
          <el-button v-if="auth.oneLoginEnt" size="mini" type="success" icon="el-icon-s-promotion" @click="oneLogin(scope.row)">一键登录</el-button>
          <el-button v-if="auth.saveEnt" size="mini" icon="el-icon-edit" type="primary" @click="setForm(scope.row)">编辑</el-button>
          <el-button v-if="auth.delEnt" size="mini" type="danger" @click="del(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination :page-sizes="[15, 30, 60, 100]" :page-size="query.limit" :total="table.total" :current-page.sync="query.page" @current-change="getList(false)" @size-change="sizeChange" small hide-on-single-page background layout="total, sizes, prev, pager, next, jumper"></el-pagination>
    
    <!--新增和编辑-->
    <el-dialog :title="formData.id?'编辑账号':'新增账号'" :close-on-click-modal="false" :visible.sync="form">
        <el-form :model="formData" label-width="100px">
            <el-form-item v-if="formData.id" label="id">{{formData.id}}</el-form-item>
            <el-form-item label="用户名">
                <el-input v-model="formData.user_name" autocomplete="off" :disabled="formData.id ? true : false"></el-input>
            </el-form-item>
            <el-form-item label="姓名">
                <el-input v-model="formData.name" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="密码">
                <el-input type="password" v-model="formData.password" :placeholder="formData.id?'为空不修改':'请输入密码'" autocomplete="off"></el-input>
            </el-form-item>
             <el-form-item label="备注">
                <el-input v-model="formData.remark" type="textarea" autocomplete="off"></el-input>
            </el-form-item>
          <el-form-item label="到期时间">
            <el-date-picker v-model="formData.expireTime" type="date" placeholder="选择日期">
            </el-date-picker>
          </el-form-item>
            <el-form-item label="状态">
                <el-select v-model="formData.status">
                    <el-option label="禁用" :value="0"></el-option>
                    <el-option label="正常" :value="1"></el-option>
                </el-select>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="form = false">取 消</el-button>
            <el-button type="primary" @click="save()">确 定</el-button>
        </div>
    </el-dialog>

  </el-card>
</template>

<script>
  import { formatDate } from '@/utils/index.js';
  import { apiGetEntList, apiSaveEnt, apiDelEnt, apiGetLoginToken } from '@/utils/api.js'
  export default {
    data() {
      return {
        auth:{
          saveEnt: this.$global.ApiList.includes(31),
          delEnt: this.$global.ApiList.includes(32),
          oneLoginEnt: this.$global.ApiList.includes(69)
        },

        query: { search_key: 'user_name',search_val: '', page:1, limit: 15 },

        table:{ loading:false, total:0, rows:[] },

        form: false,
        formData: {

        },
      }
    },
    created() {
      this.getList()
    },
    methods: {
      formatDate,

      // 一键登录
      async oneLogin({ id }) {
        const { success, data } = await apiGetLoginToken({ id: id })
        if(!success) return
        window.localStorage.setItem('adminToken', data.token)
        this.$router.push({ path: '/main' })
        setTimeout(() => {
          window.location.reload()
        }, 500);
      },

      async getList(pageInit = true) {
        if (pageInit) this.query.page = 1
        this.table.loading = true
        const { success, data } = await apiGetEntList(this.query)
        this.table.loading = false
        this.table.rows = data.rows
        this.table.total = data.total
        if(!success) return
      },

      //每页数量改变
      sizeChange(limit) {
        this.query.limit = limit
        this.getList()
      },
      //设置form
      setForm(formData = { status:1 }) {
        if (formData.expire_time) {
          formData.expireTime = new Date(formData.expire_time * 1000);
        } else {
          let time = new Date();
          formData.expireTime = time.setFullYear(time.getFullYear() + 1)
        }
        this.formData = Object.assign({}, formData)
        this.form = true
      },

      // 点击保存
      async save() {
        const loading = this.$loading()
        const { success, data } = await apiSaveEnt(this.formData)
        loading.close()
        if(!success) return
        this.$message.success(data.msg)
        this.form = false
        this.getList(false)
      },

      // 点击删除
       del({ id }) {
        this.$confirm('将永久删除该用户, 是否继续?', '删除提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          this.table.loading = true
          const { success, data } = await apiDelEnt({ id: id })
          this.table.loading = false
          if(!success) return
          this.$message.success(data.msg)
          this.getList()
        }).catch(()=>{})
      }, 
      
    }
  }
</script>

<style lang="scss">
</style>